import moment from 'moment';

export function getDateDiffToStr(currentDate: Date, pastDate: Date): string {
  const now = moment(currentDate);
  const past = moment(pastDate);
  const duration = moment.duration(now.diff(past));
  const seconds = duration.asSeconds();
  const minutes = duration.asMinutes();
  const hours = duration.asHours();
  const days = duration.asDays();
  const months = duration.asMonths();
  const years = duration.asYears();

  if (seconds <= 60) return `${Math.round(seconds * 1) / 1} seg`;
  if (minutes <= 60) return `${Math.round(minutes * 1) / 1} min`;
  if (hours <= 24) return `${Math.round(hours * 1) / 1} h`;
  if (days <= 28) return `${Math.round(days * 1) / 1} d`;
  if (months <= 12) return `${Math.round(months * 1) / 1} m`;
  return `${Math.round(years * 1) / 1} a`;
}
